import {Box, Stack, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useLocation} from 'react-router-dom';
import axios from '../../axios';
import {useAuthentication} from '../auth/hooks/useAuthentication';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import RegistrationStep1 from './RegistrationStep1';
import RegistrationStep2 from './RegistrationStep2';
import {register} from './queries/register';
import {useRegisterFormStep} from './hooks/useRegisterFormStep';


const Img = styled('img')({
  top: '33px',
  left: '34px',
  display: 'block',
  '@media (min-width: 960px)': {
    width: '403px',
  },
  width: 'auto',
  height: '387px',
  borderRadius: '5px',
});

const steps = ['Step 1', 'Step 2'];

const Registration = ({setShowNav}) => {
  const {mode} = useDarkMode();
  const {methods, handleBackStep, handleNextStep, submitting, currentStep} =
    useRegisterFormStep();

  useEffect(() => {
    const script = document.createElement('script');
    script.id = 'ohs-recaptcha';
    const token = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    script.src = `https://www.google.com/recaptcha/api.js?render=${token}`;
    document.body.appendChild(script);

    return () => {
      const script = document.getElementById('ohs-recaptcha');
      script.remove();
    };
  }, []);

  return (
    <Stack
      sx={{
        backgroundColor: mode.settings.cardBackgroundColor,
        padding: {xs: 0, md: 10, lg: 10},
      }}
      direction={'row'}
      justifyContent={'center'}
      alignItems={2 === currentStep ? 'flex-start' : 'center'}
      gap={20}
      flexWrap={'wrap'}>
      <Img alt={'Inscription'} src={`/assets/img/inscription.png`} role="img" />
      <Box width={{xs: '100%', md: '400px', lg: '600px'}}>
        <FormProvider {...methods}>
          {1 === currentStep && (
            <RegistrationStep1 handleNextStep={handleNextStep} />
          )}
          {2 === currentStep && (
            <RegistrationStep2
              handleNextStep={handleNextStep}
              handleBackStep={handleBackStep}
              loading={submitting}
            />
          )}
        </FormProvider>
      </Box>
    </Stack>
  );
};

export default Registration;
